import React, { useEffect, useState } from "react";
import styles from "./AllInfoContainer.module.scss";
import Title from "../../../../ui/Title/Title";
import { BitrixIcon } from "../../../../assets/icons/BitrixIcon";
import { LoadingComponent } from "../../../LoadingComponent/LoadingComponent";
import { ErrorComponent } from "../../../ErrorComponent/ErrorComponent";
import Select from "../../../../ui/Select/Select";
import Switcher from "../../../../ui/Switcher/Switcher";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsUpdateBitrixChatBot,
  setUpdateDataBitrixChatBot,
} from "../../../../store/slices/bitrixChatBotSlice";
import Chip from "../../../../ui/Chip/Chip";

export const AllInfoContainer = ({
  activeBitrix,
  updateBitrix,
  updatedDataBitrix,
  errorBitrix,
}) => {
  const id =
    useSelector((state) => state.user?.data?.id) ||
    localStorage.getItem("@storage_User_Id");

  const DataItem = ({ title, data, chip }) => {
    return (
      <div className={styles.dataItemContainer}>
        <div className={styles.dataItemContainerFlex}>
          <label className={styles.title}>{title}</label>
          {chip && (
            <Chip
              classNameChip={styles.chipContainer}
              active={isSwitchOn}
              title={isSwitchOn ? "Активен" : "Не активен"}
            />
          )}
        </div>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  const dispatch = useDispatch();

  const { dataAssistants } = useSelector((state) => state?.assistant);

  const [updatedBitrixChatBotData, setUpdatedBitrixChatBotData] =
    useState(null);
  const [isSwitchOn, setIsSwitchOn] = useState(activeBitrix?.assistantActive);

  const assistantName =
    dataAssistants?.find(
      (assistant) => assistant.id === updatedBitrixChatBotData?.assistantId
    )?.name || "Ассистент не найден";

  const handleToggle = () => {
    const newSwitchState = !isSwitchOn;
    setIsSwitchOn(newSwitchState);
    dispatch(setIsUpdateBitrixChatBot(true));
    setUpdatedBitrixChatBotData((prevData) => ({
      ...prevData,
      assistantActive: newSwitchState,
    }));
  };

  const selectObserver = (val) => {
    dispatch(setIsUpdateBitrixChatBot(true));
    setUpdatedBitrixChatBotData((prevData) => ({
      ...prevData,
      assistantId: val,
    }));
  };

  useEffect(() => {
    if (activeBitrix) {
      setUpdatedBitrixChatBotData({
        userId: id,
        chatBotId: activeBitrix?.bitrixBotId || null,
        assistantId: activeBitrix?.assistantId || null,
        assistantActive: activeBitrix?.assistantActive || false,
      });
      setIsSwitchOn(activeBitrix?.assistantActive);
    }
  }, [activeBitrix, id]);

  useEffect(() => {
    if (updateBitrix) {
      dispatch(setUpdateDataBitrixChatBot(updatedBitrixChatBotData));
    }
  }, [updateBitrix, updatedBitrixChatBotData, dispatch]);

  return (
    <div className={styles.container}>
      {errorBitrix && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных Bitrix Chat Bot"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}
      {activeBitrix && !errorBitrix ? (
        <>
          <div className={styles.header}>
            <div className={styles.headerInfoContainer}>
              <div className={styles.headerInfoContainerTitle}>
                <Title title={activeBitrix?.name} className={styles.title} />
                <BitrixIcon width={90} height={20} fill={"#3e8fcb"} />
              </div>
            </div>
          </div>

          {activeBitrix && !errorBitrix && (
            <>
              <div className={styles.rowData}>
                <DataItem title={"Client id"} data={activeBitrix?.clientId} />
                <DataItem title={"chatBotId"} data={activeBitrix?.id} />
                <DataItem
                  title={"Bitrix Bot id"}
                  data={activeBitrix?.bitrixBotId}
                />
              </div>

              <div className={styles.rowData}>
                <DataItem title={"Api URL"} data={activeBitrix?.apiURL} />
                <DataItem title={"Code"} data={activeBitrix?.code} />
                <DataItem title={"Openline"} data={activeBitrix?.openline} />
              </div>
            </>
          )}
          <div className={styles.headerAssistantContainer}>
            <DataItem
              title={`Ассистент`}
              chip={true}
              data={
                <Select
                  containerStyle={styles.containerSelect}
                  labelStyle={styles.labelSelect}
                  dataSelect={dataAssistants}
                  selectObserver={selectObserver}
                  nameSelectedOption={assistantName}
                />
              }
            />
            <div>
              <DataItem
                title={"Статус"}
                data={
                  <Switcher
                    switchStyle={styles.switchContainer}
                    bool={isSwitchOn}
                    onToggle={handleToggle}
                  />
                }
              />
            </div>
          </div>
        </>
      ) : (
        !errorBitrix && <LoadingComponent />
      )}
    </div>
  );
};
